import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var SelectionMultipleIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M5 16a2 2 0 012 2v2a2 2 0 01-2 2H3a2 2 0 01-2-2v-2a2 2 0 012-2h2zm17 2a1 1 0 01.117 1.993L22 20H10a1 1 0 01-.117-1.993L10 18h12zM5 18H3v2h2v-2zm0-9a2 2 0 012 2v2a2 2 0 01-2 2H3a2 2 0 01-2-2v-2a2 2 0 012-2h2zm17 2a1 1 0 01.117 1.993L22 13H10a1 1 0 01-.117-1.993L10 11h12zM5 11H3v2h2v-2zm0-9a2 2 0 012 2v2a2 2 0 01-2 2H3a2 2 0 01-2-2V4a2 2 0 012-2h2zm17 2a1 1 0 01.117 1.993L22 6H10a1 1 0 01-.117-1.993L10 4h12zM5 4H3v2h2V4z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
SelectionMultipleIcon.isCarinaIcon = true;
export default SelectionMultipleIcon;
